/**
 * A global namespace for 'animationDelay' string.
 */
const animationDelay = "animationDelay";
export default animationDelay;
